module.exports ={
  title: ['境内账户','Domestic Account'],
  balance_title: ['人民币余额','RMB balance'],
  balance_tit_detail: ['余额明细','Balance details'],
  alert_money: ['提醒金额：','Alerts amount：'],
  alert_method: ['提醒方式：','Alerts method：'],
  balance_open_alert: ['开启余额提醒','Enable Balance alerts'],
  balance_close_alert: ['关闭余额提醒','Disable Balance alerts'],
  pending_credit_amount: ['待入账金额（含手续费）','Pending Credit Amount(including fee)'],
  pending_credit_amount_content: ['待入账金额：是指易生支付即将结算给您，但尚未到达易生账户的资金','pending Cred.Amt: funds EasePay will soon settle to you but not yet received in your EasePay acct.'],
  frozen_amount: ['冻结金额','Frozen amount'],
  frozen_amount_content: ['冻结金额：是指付汇和代付中的资金','frozen amt: funds in payment and payment-on-behalf'],
  available_balance_coll_settle: ['收结汇可用余额','Available Balance for Coll & Settle'],
  top_up: ['充值','Top-Up'],
  withdrawal: ['提现','Withdrawal'],
  risk_tips: ['风险提示','Risk_tips'],
  risk_tips_content: ['目前通过网络平台开展外汇按金交易未经批准，境内个人跨境境外购房、直接进行跨境证券投资，相关外汇业务属于资本项目下业务，按照可兑换进程管理，目前尚未明确开放，直接或间接开展、参与上述相关外汇业务，涉嫌违规。请提高风险防范意识，谨防财产损失！','Currently, margin trading of foreign exchange conducted through online platforms is not approved. Cross-border property purchases overseas and direct cross-border securities investments by domestic individuals constitute capital account transactions. These businesses are managed in accordance with the progress of convertibility and have not yet been explicitly opened up at present. Directly or indirectly conducting or participating in the aforementioned foreign exchange-related businesses is suspected of violating regulations. Please enhance your risk prevention awareness and guard against property losses!'],
  withdrawal_money: ['提现金额：','Withdrawal amount：'],
  withdrawal_money_placeholder: ['请输入提现金额','enter withdrawal amount'],
  withdrawal_money_max: ['最多可提现金额：','Withdrawal_amount_max：'],
  yuan: ['元','CNY'],
  withdrawal_all: ['全部提现','Withdrawal all'],
  remark: ['备注：','Remark：'],
  remark_placeholder: ['请输入备注','enter remarks'],
  account_bankName: ['开户行：','Issuing bank：'],
  account_name: ['户名：','Account name：'],
  account_bankAccountNo: ['账号：','Account No：'],
  account_bankSwift: ['行号：','Bank code：'],
  account_phone: ['手机号：','Mobile No：'],
  account_tips: ['提示：','Tips：'],
  account_tips_content: ['提现银行信息为入网时所填信息，若银行信息有变更，请联系您的专属商务经理，申请变更。','withdrawal bank info. is the one filled in during onboarding. If bank info. changes, please contact your dedicated business manager to apply for modification.'],
  cancel: ['取消','Cancel'],
  submit: ['确 定','Submit'],
  submit_withdrawal: ['确定提现','Submit withdrawal'],
  submit_top_up: ['确定充值','Submit top_up'],
  pay_pwd: ['支付密码：','Pay_pwd：'],
  top_up_region: ['充值资金来源：','Top_up source：'],
  top_up_amount: ['充值金额：','Top_up amount：'],
  top_up_amount_placeholder: ['请输入充值金额','enter the top_up amount'],  
  top_up_method: ['充值方式：','Top_up method：'],
  use_of_funds: ['资金用途：','Fund purpose：'],
  all: ['全部','all'],
  relationship: ['与充值人关系：','Recharger Rel.：'],
  name: ['姓名：','Name：'],
  input_placeholder: ['请输入','enter'],
  select_placeholder: ['请选择','select'],
  cardId: ['身份证号：','Card Id：'],
  idStartDate: ['身份证有效期：','ID validity period：'],
  idStartDate_placeholder: ['选择日期','select date'],
  idEndDate_placeholder: ['yyyy-mm-dd 或长期','yyyy-mm-dd or long-term'],
  to: ['至','To'],
  longTime: ['长期','long-term'],
  address: ['地址：','Address：'],
  contact: ['联系方式：','Contact info：'],
  bank_info_tips: ['为保障入账成功，具体打款信息请务必严格按照如下信息填写','To ensure successful fund crediting, please strictly fill in specific payment info. With the following details'],
  accountName: ['收款人：','Payee：'],
  accountNumber: ['收款人账号/IBAN：','IBAN：'],
  accountBankName: ['收款银行：','Receiving bank：'],
  bankAddress: ['银行地址：','Bank address：'],
  receiverAddress: ['收款人地址：','Payee address：'],
  withdrawal_success_title: ['提现申请提交成功','Withdrawal appllication submitted successfully'],
  withdrawal_success_tips: ['系统将在三个工作日内处理您的提现申请','The system will process your withdrawal application within 3 working days'],
  balance_alert: ['余额提醒','Balance alert'],
  alert_money_placeholder: ['请输入提醒金额','enter the reminder amount'],
  alert_money_tips: ['提示：当账户余额小于提醒金额时发送提醒通知','Tips: a reminder notification will be sent when the account balance is less than the reminder amount'],
  sms: ['短信','SMS'],
  sms_placeholder: ['手机号','Mobile No'],
  email: ['邮件','Email'],
  email_placeholder: ['邮箱','Email address'],
  confirm: ['确认','Confirm'],
  balance_close_alert_title: ['是否确定关闭余额提醒功能 ?','Are you sure to turn off balance reminder function?'],
  pay_pwd_placeholder: ['请输入支付密码','enter pay_pwd'],
  check_withdrawal_amount_error: ['余额不足，无法提现','Insufficient balance, withdrawal not allowed'],
  open_recharge_error: ['未开通充值功能，若要开通充值，请联系您的商务经理或客服','The recharge function is not activated,please contact your business manager or customer service'],
  input_phone_placeholder: ['请输入手机号','enter mobile No'],
  input_email_placeholder: ['请输入邮箱','enter email'],
  dateTime_check1: ['开始日期不能晚于结束日期','start date cannot be later than end date'],
  dateTime_check2: ['开始日期不能晚于当前日期','start date cannot be later than current date'],
  dateTime_check3: ['结束日期不能早于当前日期','end date cannot be earlier than current date'],
  select_top_up_method_placeholder : ['请选择充值方式','select top_up method'],
  select_top_up_bank_placeholder : ['请选择充值银行','select top_up bank'],
  null: ['暂无数据','N/A'],
  list: {
    title: ['多币种钱包余额明细','Multi-currency Wallet Balance Details'],
    backWallet: ['返回钱包','Return to wallet'],
    all: ['全部','all'],
    wallet_currency: ['钱包币种：','Wallet currency：'],
    statement_type: ['流水类型：','Trans. type：'],
    balance: ['人民币余额：','RMB Balance：'],
    pending_credit_amount: ['待入账金额：','Pending Cr Amt：'],
    credit_date: ['入账时间：','Credit date：'],
    start_date: ['开始日期','start date'],
    end_date: ['结束日期','end date'],
    to: ['至','To'],
    search: ['查询','Inquiry'],
    reset: ['重置','Reset'],
    export: ['导出','Export'],
    balance_detail: ['余额明细','Balance Details'],
    trace: ['交易流水号','Trans. serial No'],
    sourceTrace: ['商户订单号','Merchant order No'],
    transaction_type: ['交易类型','Trans. type'],
    currency: ['交易币种','Trans. currency'],
    amount: ['交易金额','Trans. amount'],
    beforeAmount: ['交易前金额','Amount before trans'],
    afterAmount: ['交易后金额','Amount after trans'],
    createdTime: ['入账时间','Created time'],
    remark: ['备注','Remark'],
    export_file_name: ['商户账户明细','Merchant acct.details'],
    export_file_error: ['请稍后重试','Try again later'],
  },
  abroadList: {
    title: ['多币种钱包余额明细','Multi-currency wallet balance'],
    backWallet: ['返回钱包','Return to wallet'],
    account_label: ['账户：','Account：'],
    currency_label: ['币种：','Currency：'],
    balance_label: ['余额：','Balance：'],
    frozen_amount_label: ['冻结金额：','Frozen Amount：'],
    all: ['全部','all'],
    statement_type_label: ['流水类型：','Trans. type'],
    statement_date_label: ['流水时间：','Trans. date'],
    start_date: ['开始日期','start date'],
    end_date: ['结束日期','end date'],
    to: ['至','To'],
    search: ['查询','Inquiry'],
    reset: ['重置','Reset'],
    balance_detail: ['余额明细','Balance Details'],
    trace: ['交易流水号','Trans. serial No'],
    transactionNumber: ['平台订单号','Platform Order No'],
    account: ['账户','Account'],
    currency: ['币种','Currency'],
    statement_type: ['流水类型','Trans. type'],
    amount: ['交易金额','Trans. amount'],
    balance: ['余额','Balance'],
    statement_date: ['流水时间','Trans. date'],
  }
}